import type { IMenuSection } from "@fondationcss/ui";
import { translate } from "@fondationcss/sdk";

const MAX_SIDEBAR_GROUPS = 10;

// Menu en sections (même style que parcours) : Élève, Intervenant, Planification,
// Gestion sont des SECTIONS (avec icône), et les pages réelles sont réparties dans
// la bonne section.
// Les titres sont des getters paresseux : translate() doit être évalué au rendu, pas au
// chargement du module, sinon le menu resterait figé dans la langue de démarrage.
export const menus: IMenuSection[] = [
  {
    get title() { return translate('perspective.shell.nav.student'); },
    icon: 'user-graduate',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    permissions: ['Perspective.TimeLine.ManageOwn'],
    groups: [
      { get title() { return translate('perspective.shell.nav.dashboard'); }, icon: 'dashboard', to: '/lignedetemps/tableau-de-bord' },
      { get title() { return translate('perspective.shell.nav.myTimelines'); }, icon: 'bars-staggered', to: '/lignedetemps/visualisateur' },
    ],
  },
  {
    get title() { return translate('perspective.shell.nav.staff'); },
    icon: 'chalkboard-user',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    // Perspective.TimeLine.Manage (issue #95, portée par le rôle Intervenant) : gère les
    // lignes de temps ; le catalogue de cours relève de Perspective.Course.Manage.
    permissions: ['Perspective.TimeLine.View', 'Perspective.TimeLine.Manage'],
    groups: [
      // L'enseignant y choisit l'élève dont il veut voir les cours en cours.
      { get title() { return translate('perspective.shell.nav.dashboard'); }, icon: 'dashboard', to: '/lignedetemps/tableau-de-bord' },
      { get title() { return translate('perspective.shell.nav.timelines'); }, icon: 'bars-staggered', to: '/lignedetemps/visualisateur' },
    ],
  },
  {
    get title() { return translate('perspective.shell.nav.planning'); },
    icon: 'calendar',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    permissions: ['Core.Calendar.Manage', 'Perspective.Admissions.Reviewer', 'Perspective.FgaEnrollments.Read'],
    groups: [
      // Calendar v3 (#131) : le calendrier système n'existe plus — le lien mène à la liste.
      { get title() { return translate('perspective.shell.nav.calendar'); }, icon: 'calendar', to: '/core/calendar', permissions: ['Core.Calendar.Manage'] },
      // Aligné sur le backend : les routes Admissions n'acceptent que Reviewer.
      { get title() { return translate('perspective.shell.nav.admissionRequests'); }, icon: 'inbox', to: '/admin/systeme/inscription', permissions: ['Perspective.Admissions.Reviewer'] },
      { get title() { return translate('perspective.shell.nav.fgaAttendance'); }, icon: 'file-lines', to: '/admin/systeme/fga-frequentation', permissions: ['Perspective.FgaEnrollments.Read'] },
    ],
  },
  {
    get title() { return translate('perspective.shell.nav.management'); },
    icon: 'sliders',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    // Core.Calendar.Manage y figure pour les Rapports : un gestionnaire de calendrier doit
    // atteindre la section, ne serait-ce que pour cette seule entrée. Core.Calendar.View n'y
    // est PAS — tous les rôles la détiennent, la section s'ouvrirait à tout le monde.
    permissions: ['Perspective.Course.Manage', 'Perspective.Sites.Manage', 'Perspective.Teachers.Manage', 'Perspective.Admissions.Reviewer', 'Core.Privacy.Administrateur', 'Core.Audit.Administrateur', 'Core.Audit.Consultation', 'Core.Calendar.Manage'],
    groups: [
      // Catalogue de cours : administré via /api/Course/* (Perspective.Course.Manage).
      { get title() { return translate('perspective.shell.nav.courses'); }, icon: 'users-gear', to: '/lignedetemps/parametres2', permissions: ['Perspective.Course.Manage'] },
      // Centres (M1b-1): the shared SiteManagement, guarded by Perspective.Sites.Manage.
      { get title() { return translate('perspective.shell.nav.centres'); }, icon: 'building', to: '/admin/centres', permissions: ['Perspective.Sites.Manage'] },
      // Enseignants (M1b-2): the shared TeacherManagement, guarded by Perspective.Teachers.Manage.
      { get title() { return translate('perspective.shell.nav.teachers'); }, icon: 'chalkboard-user', to: '/admin/enseignants', permissions: ['Perspective.Teachers.Manage'] },
      // Fondation's schedule pattern pages: routed by Fondation, reachable from no menu until now.
      { get title() { return translate('perspective.shell.nav.schedulePatterns'); }, icon: 'clock', to: '/core/schedule-patterns', permissions: ['Core.Calendar.Manage'] },
      { get title() { return translate('perspective.shell.nav.enrollment'); }, icon: 'file-signature', to: '/admin/systeme/inscription-config', permissions: ['Perspective.Admissions.Reviewer'] },
      { get title() { return translate('perspective.shell.nav.privacy'); }, icon: 'shield-halved', to: '/admin/systeme/privacy', permissions: ['Core.Privacy.Administrateur'] },
      { get title() { return translate('perspective.shell.nav.auditLog'); }, icon: 'clipboard-list', to: '/admin/systeme/audit', permissions: ['Core.Audit.Administrateur', 'Core.Audit.Consultation'] },
      { get title() { return translate('perspective.shell.nav.importExport'); }, icon: 'download', to: '/admin/import-export', permissions: ['Perspective.Course.Manage'] },
      // Rapports PDF. Cible du bouton « Imprimer en PDF » du calendrier, d'où la même
      // permission que l'entrée Calendrier.
      { get title() { return translate('perspective.shell.nav.reports'); }, icon: 'file-lines', to: '/admin/rapports', permissions: ['Core.Calendar.Manage'] },
    ],
  },
];
